import { Component, inject } from '@angular/core';
import { ModalRef, ModalModule, ButtonV2Module } from '@schenck/rotec-components';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'rm-iso-calculation-info-modal',
  templateUrl: './iso-calculation-info-modal.component.html',
  styleUrls: [],
  imports: [ModalModule, TranslatePipe, TranslateDirective, ButtonV2Module],
})
export class IsoCalcualtionInfoModalComponent {
  private readonly modalRef = inject(ModalRef);

  public close(): void {
    this.modalRef.close();
  }
}
